import { useContext, useMemo } from 'react';
import { CalendarContext } from '@/contexts/CalendarContext';
import { isDate } from 'date-fns';
import { Stack, Typography, Box } from '@mui/material';
import ActivityCard from '@/components/activity/ActivityCard';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const OngoingActivities = () => {
  const { weekInstances } = useContext(CalendarContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const ongoingInstances = useMemo(
    () =>
      weekInstances
        ? weekInstances.filter(
            (instance) => isDate(instance.dateIsStarted) && !isDate(instance.dateIsCompleted),
          )
        : [],
    [weekInstances],
  );

  const viewActivity = (activityInstanceId: number) => () => {
    navigate(`/activity/${activityInstanceId}`);
  };

  return (
    <Stack spacing={2}>
      {ongoingInstances.length > 0 && (
        <>
          <Typography variant="h6">{t('Ongoing Activities')}</Typography>
          {ongoingInstances.map((instance, index) => (
            <Box onClick={viewActivity(instance.activityInstanceId)} key={index} display={'block'}>
              <ActivityCard key={index} activityInstance={instance} type={'ongoing'}></ActivityCard>
            </Box>
          ))}
        </>
      )}
    </Stack>
  );
};

export default OngoingActivities;
